// extracted by mini-css-extract-plugin
export var articlesSection = "recent-articles-module--articles-section--vyt6D";
export var buttonHolder = "recent-articles-module--button-holder--Rom67";
export var articlesSectionInner = "recent-articles-module--articles-section-inner--_RRiT";
export var articlesSectionContent = "recent-articles-module--articles-section-content--1_4p4";
export var articleBlockHolder = "recent-articles-module--article-block-holder--Ftnyr";
export var articleBlock = "recent-articles-module--article-block--29oI6";